import { ENV } from '@shared/config';

export async function enableScanning() {
  if (ENV.IS_DEVELOPMENT_MODE) {
    const { scan } = await import('react-scan');

    scan({ enabled: false });
  }
}
